import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import {
  OptionSelect,
  SearchSelect,
} from '../../../../shared/components/search-select/search-select';
import { Componente } from '../../../../core/models/component.interface';
import {
  AssistanceService,
  AssistanceServiceDTO,
} from '../../../../core/models/assistanceservice.interface';
import { ServiceActivity } from '../../../../core/models/serviceactivity.interface';
import { Location } from '../../../../core/models/location.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ComponentService } from '../../../../core/services/component/component';
import { LoadingService } from '../../../../core/services/loading/loading';
import { ServiceactivityService } from '../../../../core/services/serviceactivity/serviceactivity-service';
import { LocationService } from '../../../../core/services/location/location-service';
import { AssistanceserviceService } from '../../../../core/services/assistanceservice/assistanceservice-service';
import { FormUtils } from '../../../../shared/utils';
import { switchMap } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ServiceAssistance } from '../../../../core/services/assistance/assistance-service';
import { Assistance } from '../../../../core/models/assistance.interface';
import { MatOptionModule } from '@angular/material/core';
import { SearchfilterPipe } from '../../../../shared/pipes/searchfilter.pipe';
import { MatSelectModule } from '@angular/material/select';
import { TermPipe } from '../../../../shared/pipes/term.pipe';
import { TermKey } from '../../../../core/models/terminology.interface';
import { LifePlan } from '../../../../core/models/lifeplan.interface';
import { Territory } from '../../../../core/models/territory.interface';
import { LifeplanService } from '../../../../core/services/lifeplan/lifeplan';
import { TerritoryService } from '../../../../core/services/territory/territory';

@Component({
  selector: 'app-assistanceservice-form',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
    SearchSelect,
    MatSelectModule,
    MatOptionModule,
    SearchfilterPipe,
    TermPipe,
  ],
  templateUrl: './assistanceservice-form.html',
  styleUrl: './assistanceservice-form.scss',
})
export class AssistanceserviceForm {
  private dialogData = inject(MAT_DIALOG_DATA, { optional: true });
  fromList = this.dialogData?.fromList ?? false;
  
  assistanceservice: string | null = null;
  errorMsg: string[] | null = null;
  termKey = TermKey;
  assistanceserviceSelected: AssistanceService | null = null;
  assistance: Assistance | null = null;

  componenteSelected: OptionSelect[] = [];
  listComponente: Componente[] = [];
  selectComponente: OptionSelect | null = null;
  componenteSeleccionado: Componente | null = null;

  serviceActivitySelected: OptionSelect[] = [];
  listServiceactivity: ServiceActivity[] = [];
  selectServiceActivity: OptionSelect | null = null;
  serviceActivitySeleccionado: ServiceActivity | null = null;

  locationSelected: OptionSelect[] = [];
  listLocation: Location[] = [];
  selectLocation: OptionSelect | null = null;
  locationSeleccionado: Location | null = null;

  lifeSelected: OptionSelect[] = [];
  listLifeplan: LifePlan[] = [];
  selectLifeplan: OptionSelect | null = null;
  lifeplanSeleccionado: LifePlan | null = null;

  territorySelected: OptionSelect[] = [];
  listTerritory: Territory[] = [];
  selectTerritory: OptionSelect | null = null;
  territorySeleccionado: Territory | null = null;

  assistanceSelected: OptionSelect[] = [];
  listAssistance: Assistance[] = [];
  selectassistance: OptionSelect | null = null;
  assistanceSeleccionado: Assistance | null = null;

  private formBuilder = inject(FormBuilder);
  searchControl = new FormControl();

  constructor(
    private dialogRef: MatDialogRef<AssistanceserviceForm>,
    private toastr: ToastrService,
    private componentService: ComponentService,
    private loadingService: LoadingService,
    private serviceactivityService: ServiceactivityService,
    private locationService: LocationService,
    private serviceAssistance: ServiceAssistance,
    private assistanceserviceService: AssistanceserviceService,
    private serviceLifeplan: LifeplanService,
    private serviceTerritory: TerritoryService,
  ) {}

  ngOnInit(): void {
    this.fetchData();
    this.assistanceserviceService.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });
    this.serviceAssistance.selectedAssistance$.subscribe((assistance) => {
      this.assistance = assistance;
      this.assistanceserviceForm.get('assistence')?.setValue(this.assistance?.id || 0);
    });
  }

  private fetchData() {
    this.componentService
      .getComponents()
      .pipe(
        switchMap((components) => {
          this.listComponente = components;
          this.componenteSelected = this.componentService.getOptionComponent(components);
          return this.serviceLifeplan.getLifeplans();
        }),
        switchMap((lifePlans) => {
          this.listLifeplan = lifePlans;
          this.lifeSelected = this.serviceLifeplan.getOptionLifeplan(lifePlans);
          return this.serviceTerritory.getTerritories();
        }),
        switchMap((territories) => {
          this.listTerritory = territories;
          this.territorySelected = this.serviceTerritory.getOptionTerritory(territories);
          return this.locationService.getLocations();
        }),
        switchMap((locations) => {
          this.listLocation = locations;
          this.locationSelected = this.locationService.getOptionLocations(locations);
          return this.serviceAssistance.getAssistances();
        }),
        switchMap((assistance) => {
          this.listAssistance = assistance;
          this.assistanceSelected = this.serviceAssistance.getOptionAssistance(assistance);
          return this.serviceactivityService.getServiceActivities();
        }),
        switchMap((serviceActivities) => {
          this.listServiceactivity = serviceActivities;
          this.serviceActivitySelected =
            this.serviceactivityService.getOptionServiceActivity(serviceActivities);
          return this.assistanceserviceService.selectedAssistanceService$;
        }),
      )
      .subscribe((assistanceservice) => {
        if (assistanceservice) {
          this.assistanceservice = String(assistanceservice.id);
          this.assistanceserviceSelected = assistanceservice;
          this.assistanceserviceForm.patchValue({
            ...this.assistanceserviceSelected,
            components: this.assistanceserviceSelected.components?.id || 0,
            locations: assistanceservice.locations.map((location) => location.id),
            assistence: this.assistance?.id || 0,
            lifePlan: assistanceservice.lifePlan.map((lifePlan) => lifePlan.id),
            territory: assistanceservice.territory.map((territory) => territory.id),
          });
          const componentsOpt = this.componenteSelected.find((el) => {
            if (this.assistanceserviceSelected) {
              return el.value === this.assistanceserviceSelected.components?.id;
            }
            return false;
          });

          const assistenceOpt = this.assistanceSelected.find((el) => {
            if (this.assistanceserviceSelected) {
              return el.value === this.assistanceserviceSelected.assistence?.id;
            }
            return false;
          });
          if (typeof componentsOpt !== 'undefined') {
            this.selectComponente = componentsOpt;
          }
          if (typeof assistenceOpt !== 'undefined') {
            this.selectassistance = assistenceOpt;
          }
        }
      });
  }

  assistanceserviceForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(150)]],
    components: [0, [Validators.required]],
    locations: this.formBuilder.control<number[]>([], Validators.required),
    assistence: [0, [Validators.required]],
    lifePlan: this.formBuilder.control<number[]>([], Validators.required),
    territory: this.formBuilder.control<number[]>([], Validators.required),
  });

  getcomponents(id: number) {
    const index = this.listComponente.findIndex((componente) => componente.id === id);
    this.componenteSeleccionado = this.listComponente[index];
  }

  onComponentsSelected(component: OptionSelect) {
    this.assistanceserviceForm.get('components')?.setValue(component.value as number);
    this.getcomponents(component.value as number);
  }

  getAssistence(id: number) {
    const index = this.listAssistance.findIndex((assistence) => assistence.id === id);
    this.assistanceSeleccionado = this.listAssistance[index];
  }

  onAssistenceSelected(assistance: OptionSelect) {
    this.assistanceserviceForm.get('assistence')?.setValue(assistance.value as number);
    this.getAssistence(assistance.value as number);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveAssistanceserviceForm() {
    const payload = this.assistanceserviceForm.value as AssistanceServiceDTO;
    if (this.assistanceserviceForm.status === 'VALID' && !this.assistanceservice) {
      this.loadingService.show(true);
      this.assistanceserviceService.createAssistanceService(payload).subscribe({
        next: (assistanceservice) => {
          this.loadingService.show(false);
          const msg = `El servicio de asistencia ${assistanceservice.name} fue CREADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    } else if (this.assistanceserviceForm.status === 'VALID' && this.assistanceservice) {
      this.loadingService.show(true);
      const id = Number(this.assistanceservice);
      this.assistanceserviceService.UpdateAssistanceService(id, { ...payload, id: id }).subscribe({
        next: (assistanceservice) => {
          this.loadingService.show(false);
          const msg = `El servicio de asistencia ${assistanceservice.name} fue EDITADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    }
  }
  getComponenteValue() {
    return this.selectComponente;
  }

  getassistanceValue() {
    return this.selectassistance;
  }
}
